import { render, staticRenderFns } from "./ReleaseDateForm.vue?vue&type=template&id=272c7840&"
import script from "./ReleaseDateForm.vue?vue&type=script&lang=js&"
export * from "./ReleaseDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports